//Main Javascript
document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const html = document.documentElement;
  const mainContent = document.querySelector('main');

  //Ativar modo contraste
  const btnContrast = document.getElementById('btn-active-contrast-mode');
  const accessibilityWrapper = document.getElementById('access-info-wrapper');
  const accessToggle = document.getElementById('access-open');
  const CONTRAST_STORAGE_KEY = 'tce-magazine-contrast-active';

  const updateAccessibilityWrapper = () => {
    if (!accessibilityWrapper) return;

    const isContrastActive = body.classList.contains('contrast-active');
    const vlibrasContainer = document.getElementById('vlibras-container');
    const isVLibrasEnabled =
      vlibrasContainer && vlibrasContainer.classList.contains('enabled');

    if (isContrastActive || isVLibrasEnabled) {
      accessibilityWrapper.classList.add('active');
    } else {
      accessibilityWrapper.classList.remove('active');
    }
  };

  const closeAccessibilityWrapper = () => {
    if (accessToggle) {
      accessToggle.checked = false;
    }
  };

  const savedContrastState = localStorage.getItem(CONTRAST_STORAGE_KEY);
  if (savedContrastState === 'true') {
    body.classList.add('contrast-active');
  }

  updateAccessibilityWrapper();

  if (btnContrast) {
    btnContrast.addEventListener('click', () => {
      const isActive = body.classList.contains('contrast-active');

      if (isActive) {
        body.classList.remove('contrast-active');
        localStorage.setItem(CONTRAST_STORAGE_KEY, 'false');
      } else {
        body.classList.add('contrast-active');
        localStorage.setItem(CONTRAST_STORAGE_KEY, 'true');
      }

      closeAccessibilityWrapper();
      updateAccessibilityWrapper();
    });
  }

  if (accessibilityWrapper) {
    const vlibrasContainer = document.getElementById('vlibras-container');
    if (vlibrasContainer) {
      const observer = new MutationObserver(updateAccessibilityWrapper);
      observer.observe(vlibrasContainer, {
        attributes: true,
        attributeFilter: ['class'],
      });
    }
    updateAccessibilityWrapper();
  }

  //Abrir form de busca
  const btnOpenSearch = document.getElementById('btn-open-search');
  const formSearch = document.getElementById('form-search');

  if (btnOpenSearch) {
    btnOpenSearch.addEventListener('click', () => {
      const isOpen = formSearch.classList.toggle('header__form-search--open');
      btnOpenSearch.setAttribute('aria-expanded', isOpen);
      btnOpenSearch.setAttribute(
        'aria-label',
        isOpen ? 'Fechar busca' : 'Abrir busca'
      );

      if (isOpen) {
        const input = formSearch.querySelector('input');
        setTimeout(() => input.focus(), 100);
      }
    });
  }

  //Menu mobile
  const menuHamburger = document.getElementById('menu-hamburger');
  const navHeader = document.querySelector('.header__nav');
  // Elementos focáveis dentro do menu
  let focusableElements = [];
  let firstFocusable = null;

  if (menuHamburger) {
    menuHamburger.addEventListener('click', () => {
      const isOpen = menuHamburger.classList.toggle('menu-hamburger--opened');
      menuHamburger.setAttribute('aria-expanded', isOpen);
      menuHamburger.setAttribute(
        'aria-label',
        isOpen ? 'Fechar menu' : 'Abrir menu'
      );

      if (isOpen) {
        if (mainContent) {
          mainContent.setAttribute('inert', '');
          mainContent.setAttribute('aria-hidden', 'true');
        }
        body.style.overflowY = 'hidden';
        navHeader.classList.add('header__nav--visible');

        // Foca no primeiro item do menu
        setupFocusTrap();
        setTimeout(() => {
          if (firstFocusable) firstFocusable.focus();
        }, 100);
      } else {
        if (mainContent) {
          mainContent.removeAttribute('inert');
          mainContent.removeAttribute('aria-hidden');
        }
        body.style.overflowY = 'auto';
        navHeader.classList.remove('header__nav--visible');
      }
    });

    // Fecha o menu ao clicar em um link
    const mobileLinks = navHeader.querySelectorAll('.header__menu-link');
    mobileLinks.forEach((link) => {
      link.addEventListener('click', () => {
        if (mainContent) {
          mainContent.removeAttribute('inert');
          mainContent.removeAttribute('aria-hidden');
        }
        body.style.overflowY = 'auto';
        menuHamburger.classList.remove('menu-hamburger--opened');
        menuHamburger.setAttribute('aria-expanded', 'false');
        menuHamburger.setAttribute('aria-label', 'Abrir menu');
        navHeader.classList.remove('header__nav--visible');
      });
    });

    // Fecha o menu com ESC
    document.addEventListener('keydown', (e) => {
      if (
        e.key === 'Escape' &&
        navHeader.classList.contains('header__nav--visible')
      ) {
        menuHamburger.click();
        menuHamburger.focus();
      }
    });

    // Função para configurar o trap de foco
    function setupFocusTrap() {
      focusableElements = navHeader.querySelectorAll('a[href]');

      if (focusableElements.length > 0) {
        firstFocusable = focusableElements[0];
      }
    }
  }
});
